import React from "react";
import LandingForm from "./LandingForm/landingForm";
import RenderChildren from "../../../hoc/renderChildren";
import { Link } from 'react-router-dom';
import Waypoint from 'react-waypoint';
import EventListener from 'react-event-listener';

import "./floatingForm.scss";

class FloatingForm extends React.Component {
  state = {
    sticky: false,
    collapsed: false,
    height: '0px'
  };

  handleEnter = () => {
    this.setState({ sticky: false, height: '0px', collapsed: false });
  };

  handleLeave = ({ currentPosition }) => {
    if (currentPosition === 'above' && this.wrapper) {
      let height = this.wrapper.getBoundingClientRect().height;
      this.setState({ sticky: true, height: height, collapsed: true });
    }
  };

  isFocusOnInputOrSelectElement = () => {
    return document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'SELECT';
  };

  handlePositionChange = () => {
    if (this.state.sticky && !this.state.collapsed && !this.isFocusOnInputOrSelectElement() ) {
      this.collapseForm();
    }
  };

  collapseForm = () => {
    this.setState({ collapsed: true });
  };

  expandForm = () => {
    this.setState({ collapsed: false });
  };

  render = () => {
    const stickyStyles = ['sticky'];
    if (this.state.sticky) stickyStyles.push('stuck');
    const formStyle = this.state.collapsed ? "form-collapsed" : "form-expanded";

    const collapseButton = (
      <button
        className="collapse-button m-0 p-0"
        aria-controls="expandable-floating-form"
        aria-expanded={this.state.collapsed}
        aria-label="Toggle check your rate form"
        onClick={this.collapseForm}>
        <span><i className="material-icons mr-0">expand_less</i></span>
      </button>);

    const stickyHeader = (
      <div className="form-header pt-2 px-3">
        <span className="barclays-logo-blue barclays-logo-blue-sm"/>
        {!this.state.collapsed && collapseButton}
      </div>);

    return (
      <RenderChildren>
        <EventListener
          target="window"
          onResize={this.handlePositionChange}
          onScroll={this.handlePositionChange}
        />
        <Waypoint
          scrollableAncestor={window}
          onEnter={this.handleEnter}
          onLeave={this.handleLeave}
        />
        <div id="floating-form-placeholder" style={{ paddingBottom: this.state.height }}/>
        <div ref={(el) => { this.wrapper = el; }} className={stickyStyles.join(' ')}>
          {this.state.sticky && stickyHeader}
          <div className={`form-overlay ${formStyle}`}>
            <div className="col-12 text-center">
              <button
                id="expand-button"
                className="w-100 btn bcus-btn bcus-btn-secondary-dark-cyan bottom-shadow my-2"
                aria-controls="expandable-floating-form"
                aria-expanded={this.state.collapsed}
                aria-label="Toggle check your rate form"
                onClick={this.expandForm}>
                Check your rate
              </button>
            </div>
            <div className="col-12 text-center my-3">
              <Link to="/" className="text-barclays-secondary-dark-cyan invitation-code-link">Have an invitation code?</Link>
            </div>
          </div>
          <div id="expandable-floating-form" className={`form-wrapper ${formStyle}`}>
            <LandingForm/>
          </div>
        </div>
      </RenderChildren>
    );
  }
}

export default FloatingForm;
